import {useState} from 'react';
import {Box} from '@mui/material';
import {Language} from '../../context/LanguageContext';
import '../../assets/styles/uploadDataCenterCard.scss';
import {
  Getah,
  IconCollectionBookmark,
  IconExpandContent,
  PalmOil,
} from '../../assets';
export default function ProgramKerjaCard({
  text,
  code,
  jenisKerja,
  jenisTanaman,
  onClick,
  options = [],
}) {
  const [openMore, setOpenMore] = useState(false);
  const {newObj, language} = Language();
  return (
    <Box className='udcc_card_ctr col'>
      <Box className='udcc_card_content' onClick={onClick}>
        <div className='udcc_card_text'>
          <p className='text_code'>
            {newObj.CodeWord[language]} {code}
          </p>
          <p className='text_main'>{text}</p>
        </div>
        <div className='udcc_card_icon'>
          <img src={IconExpandContent} alt='' />
        </div>
      </Box>
      <div className='udcc_card_content bottom'>
        <div className='udcc_jenis_kerja'>
          <img src={IconCollectionBookmark} alt='' /> <p>{jenisKerja}</p>
        </div>
        <div className='udcc_jenis_tanaman'>
          {(jenisTanaman === 'Sawit' || jenisTanaman === 'Sawit/Getah') && (
            <img src={PalmOil} alt='' />
          )}
          {(jenisTanaman === 'Getah' || jenisTanaman === 'Sawit/Getah') && (
            <img src={Getah} alt='' />
          )}
        </div>
      </div>
    </Box>
  );
}
